import { render, staticRenderFns } from "./recipe-cna-ques.vue?vue&type=template&id=28df6cbb&scoped=true&"
import script from "./recipe-cna-ques.vue?vue&type=script&lang=js&"
export * from "./recipe-cna-ques.vue?vue&type=script&lang=js&"
import style0 from "./recipe-cna-ques.vue?vue&type=style&index=0&id=28df6cbb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28df6cbb",
  null
  
)

export default component.exports